import React, { Component } from "react";
import PropTypes from "prop-types";
import HtmlParser, { domToReact } from "html-react-parser";
import ReactDOMServer from "react-dom/server";
import axios from "axios";
import { ContentState, convertFromHTML, convertToRaw } from "draft-js";
import SettingsIcon from 'mdi-react/SettingsIcon';
import { Button, Badge, Modal } from "react-bootstrap";

import { get } from "../../../utils/DeApi";

import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import { Fragment } from "react";

class EntitiesExtraction extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    this.state = {};
  }

  fetchDocument() {
    const { catalogued } = this.props;
    this.setState({ error: null, isLoading: true });

    const filing = catalogued.filing;
    const doc = filing.documentFormatFiles.find(
      (item) => item.type === catalogued.formType
    );

    let documentUrl =
      "https://dealsense-filing.s3.us-west-2.amazonaws.com/" +
      filing.filedAt.split("T").shift() +
      "/" +
      filing.accessionNo +
      "/" +
      doc.documentUrl.split("/").pop();
      // console.log("this is document URL: ", documentUrl)
    axios
      .get(documentUrl)
      .then((response) => {
        var documentHTML = this.parseHTML(response.data);
        const blocksFromHTML = convertFromHTML(documentHTML);
        const contentState = ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap
        );

        let structured = contentState.hasText()
          ? convertToRaw(contentState)
          : null;

        this.parseDealAmount(structured);
        this.parseABR(structured);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  fetchEntities(text) {
    const entitiesPromise = get(`entities/deal-amount`, {
      params: { paragraph: text },
    });

    entitiesPromise.promise
      .then((response) => {
        var entities = response.data;
        var dealAmounts = entities.filter(
          (entity) => entity.Text.match(/\$/) || entity.Text.match(/€/)
        );
        this.setState({
          text: text,
          dealAmounts: dealAmounts,
          isLoading: false,
          error: null,
        });
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });

    this.subscribedPromises.push(entitiesPromise);
  }

  parseHTML(html) {
    const { filing } = this.props;
    const options = {
      replace: ({ name, children, attribs }) => {
        if (name === "font") {
          return (
            <font style={{ fontSize: 12 }}>
              {domToReact(children, options)}
            </font>
          );
        }

        if (name === "a") {
          return (
            <a
              href={`https://www.sec.gov/Archives/edgar/data/${
                filing.cik
              }/${filing.accessionNo.replace(/-/gi, "")}/${attribs.href}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              {domToReact(children, options)}
            </a>
          );
        }

        if (name === "img") {
          return (
            <img
              alt={attribs.alt || filing.accessionNo}
              src={`https://www.sec.gov/Archives/edgar/data/${
                filing.cik
              }/${filing.accessionNo.replace(/-/gi, "")}/${attribs.src}`}
            />
          );
        }
      },
    };

    try {
      return ReactDOMServer.renderToString(HtmlParser(html, options));
    } catch (e) {
      return html;
    }
  }

  parseDealAmount(structured) {
    let blocks = structured.blocks
      .filter((block) => {
        let text = block.text;
        return (
          // Currency Amount
          (text.match(/\$/) || text.match(/€/)) &&
          // Recitals Section
          ((text.includes("Borrower") &&
            text.includes("Lender") &&
            text.toLowerCase().includes("credit") &&
            (text.includes("conditions") || text.includes("terms")) &&
            (text.includes("purpose") || text.includes("used"))) ||
            // Definition Section
            text.includes(`Commitment” means`) ||
            text.includes(`Commitments” means`) ||
            text.includes(`Commitment”:`) ||
            text.includes(`Commitments”:`) ||
            text.includes("Commitment” shall mean") ||
            text.includes("Commitments” shall mean") ||
            text.includes("Commitment Amount” shall mean"))
        );
      })
      .map((block) => block.text);
    var text = blocks.join("\n\r\n\r\n\r");

    if (text.length > 1000) text = text.substring(0, 4096);
    if (text) this.fetchEntities(text);
    else
      this.setState({
        text: text,
        dealAmounts: [],
        isLoading: false,
        error: null,
      });
  }

  parseABR(structured) {
    let blocks = structured.blocks
      .filter((block) => {
        let text = block.text;
        return (
          text.includes("Benchmark Replacement") ||
          text.includes("Benchmark Transition Event") ||
          text.includes("Benchmark Administration Interest") ||
          text.includes("successor benchmark rate") ||
          text.includes("alternative benchmarks") ||
          text.includes("Inability to Determine Rates") ||
          text.includes("Term SOFR Transition Event") ||
          text.includes("Alternate Base Rate") ||
          text.includes("Early Opt-in")
        );
      })
      .map((block) => block.text);
    var text = blocks.join("\n\r\n\r\n\r");
    if (text.length > 1000) text = text.substring(0, 4096);
    this.setState({
      abrText: text,
    });
  }

  render() {
    const { isLoading, error, dealAmounts, text, abrText } = this.state;

    if (isLoading) return <Loader />;
    if (error) return <ErrorHandler error={error} />;
    return (
      <Fragment>
        <Button
          variant="null"
          size="sm"
          className="p-1 color-deal-style"
          onClick={() => this.fetchDocument()}
        >
          <SettingsIcon size={20} />
        </Button>{" "}
        {dealAmounts &&
          dealAmounts.map((dealAmount, index) => (
            <Badge variant="info" key={index} className="ml-1 mr-1 mt-1">
              {dealAmount.Text}
            </Badge>
          ))}
        {!!dealAmounts && !dealAmounts.length && (
          <Badge className="ml-1 mr-1">not found</Badge>
        )}
        {text && (
          <Fragment>
            <Button
              className="mt-1"
              variant="outline-success"
              size="xs"
              onClick={() => {
                this.setState({ showDealAmountText: true });
              }}
            >
              Amount
            </Button>

            <Modal
              animation={false}
              show={this.state.showDealAmountText}
              backdrop={"static"}
              scrollable={"true"}
              size="lg"
            >
              <Modal.Body>
                <p>
                  {dealAmounts &&
                    dealAmounts.map((dealAmount, index) => (
                      <Badge variant="info" key={index} className="ml-1 mr-1">
                        {dealAmount.Text}
                      </Badge>
                    ))}
                </p>
                <div style={{ whiteSpace: "pre-wrap", fontSize: 14 }}>
                  {text}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => this.setState({ showDealAmountText: false })}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </Fragment>
        )}{" "}
        {abrText && (
          <Fragment>
            <Button
              variant="outline-success"
              className="mt-1"
              size="xs"
              onClick={() => {
                this.setState({ showABRText: true });
              }}
            >
              ABR
            </Button>

            <Modal
              animation={false}
              show={this.state.showABRText}
              backdrop={"static"}
              size="lg"
              scrollable={"true"}
            >
              <Modal.Body>
                <div style={{ whiteSpace: "pre-wrap", fontSize: 14 }}>
                  {abrText}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => this.setState({ showABRText: false })}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

EntitiesExtraction.propTypes = {
  catalogued: PropTypes.object.isRequired,
};

export default EntitiesExtraction;
